// Dependencies
import React, { Component } from 'react';

// Primereact imports
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { FileUpload } from 'primereact/fileupload';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Styling
import './allowance-expense-submission.scss';

// Utils
import { ASSOCIATE_SUBMISSION, ALLOWANCE_APPROVED, ALLOWANCE_EXPENSE_TYPE_BUS, ALLOWANCE_EXPENSE_TYPE_HOTEL, ALLOWANCE_EXPENSE_TYPE_MEAL, ALLOWANCE_EXPENSE_TYPE_PLANE, ALLOWANCE_EXPENSE_TYPE_TAXI, ALLOWANCE_EXPENSE_TYPE_TRAIN, DECISION_WAIT_EXPENSE_SUBMISSION, DECISION_WAIT_PAYMENT, DIRECTION_APPROVAL, FINANCE_APPROVAL, ORGANIC_UNIT_APPROVAL, UNIT_KM_VALUE } from '../../../common/constants';
import { ALLOWANCE_DAILY_TYPE_100, ALLOWANCE_DAILY_TYPE_25, ALLOWANCE_DAILY_TYPE_50, ALLOWANCE_DAILY_TYPE_75 } from '../../../common/lists/allowance';
import { convertBase64ToArrayBuffer, downloadFile } from '../../../common/utils/download-utils';

// Services
import AllowanceService from '../../../redux/services/allowance';

class AllowanceExpenseSubmissionComponent extends Component {

    constructor(props) {
        super(props);
        this.busInvoiceUploadRef = React.createRef();
        this.trainInvoiceUploadRef = React.createRef();
        this.taxiInvoiceUploadRef = React.createRef();
        this.planeInvoiceUploadRef = React.createRef();
        this.hotelInvoiceUploadRef = React.createRef();
        this.mealInvoiceUploadRef = React.createRef();
        this.state = {
            hasBusExpenses: false,
            hasTrainExpenses: false,
            hasTaxiExpenses: false,
            hasCarExpenses: false,
            hasPlaneExpenses: false,
            hasMealExpenses: false,
            hasHotelExpenses: false,
            invoicesToRemove: [],
            trainInvoices: [],
            busInvoices: [],
            planeInvoices: [],
            taxiInvoices: [],
            hotelInvoices: [],
            mealInvoices: [],
            carKms: null,
            carTotal: null,
            busTotal: null,
            trainTotal: null,
            planeTotal: null,
            taxiTotal: null,
            mealNumber: null,
            mealTotal: null,
            hotelNumNights: null,
            hotelTotal: null,
            dailyEntries: [
                { allowanceDayType: ALLOWANCE_DAILY_TYPE_25, description: this.props.t("allowances.dialog.daily.25-days-description"), numDays: 0, total: 0, unitPrice: 0 },
                { allowanceDayType: ALLOWANCE_DAILY_TYPE_50, description: this.props.t("allowances.dialog.daily.50-days-description"), numDays: 0, total: 0, unitPrice: 0 },
                { allowanceDayType: ALLOWANCE_DAILY_TYPE_75, description: this.props.t("allowances.dialog.daily.75-days-description"), numDays: 0, total: 0, unitPrice: 0 },
                { allowanceDayType: ALLOWANCE_DAILY_TYPE_100, description: this.props.t("allowances.dialog.daily.complete-days-description"), numDays: 0, total: 0, unitPrice: 0 }
            ],
            dailyTotalData: null,
            // Validaton messages
            hasBusTotal: true,
            hasCarKms: true,
            hasHotelNumNights: true,
            hasHotelTotal: true,
            hasMealNumber: true,
            hasMealTotal: true,
            hasPlaneTotal: true,
            hasTaxiTotal: true,
            hasTrainTotal: true,
            hasBusInvoices: true,
            hasTrainInvoices: true,
            hasTaxiInvoices: true,
            hasPlaneInvoices: true,
            hasHotelInvoices: true,
            hasMealInvoices: true,
        };
    }

    componentDidMount() {
        let trainInvoices = [];
        let busInvoices = [];
        let planeInvoices = [];
        let taxiInvoices = [];
        let hotelInvoices = [];
        let mealInvoices = [];

        if(this.props.allowance.invoiceData !== null) {
            for (let i = 0; i < this.props.allowance.invoiceData.invoiceDocuments.length; i++) {
                if(this.props.allowance.invoiceData.invoiceDocuments[i].expenseType === ALLOWANCE_EXPENSE_TYPE_BUS) {
                    busInvoices.push({
                        documentRef: this.props.allowance.invoiceData.invoiceDocuments[i].documentRef,
                        fileContent: null,
                        filename: this.props.allowance.invoiceData.invoiceDocuments[i].filename,
                    });
                }

                if(this.props.allowance.invoiceData.invoiceDocuments[i].expenseType === ALLOWANCE_EXPENSE_TYPE_TRAIN) {
                    trainInvoices.push({
                        documentRef: this.props.allowance.invoiceData.invoiceDocuments[i].documentRef,
                        fileContent: null,
                        filename: this.props.allowance.invoiceData.invoiceDocuments[i].filename,
                    });
                }
                
                if(this.props.allowance.invoiceData.invoiceDocuments[i].expenseType === ALLOWANCE_EXPENSE_TYPE_PLANE) {
                    planeInvoices.push({
                        documentRef: this.props.allowance.invoiceData.invoiceDocuments[i].documentRef,
                        fileContent: null,
                        filename: this.props.allowance.invoiceData.invoiceDocuments[i].filename,
                    });
                }

                if(this.props.allowance.invoiceData.invoiceDocuments[i].expenseType === ALLOWANCE_EXPENSE_TYPE_TAXI) {
                    taxiInvoices.push({
                        documentRef: this.props.allowance.invoiceData.invoiceDocuments[i].documentRef,
                        fileContent: null,
                        filename: this.props.allowance.invoiceData.invoiceDocuments[i].filename,
                    });
                }

                if(this.props.allowance.invoiceData.invoiceDocuments[i].expenseType === ALLOWANCE_EXPENSE_TYPE_HOTEL) {
                    hotelInvoices.push({
                        documentRef: this.props.allowance.invoiceData.invoiceDocuments[i].documentRef,
                        fileContent: null,
                        filename: this.props.allowance.invoiceData.invoiceDocuments[i].filename,
                    });
                }

                if(this.props.allowance.invoiceData.invoiceDocuments[i].expenseType === ALLOWANCE_EXPENSE_TYPE_MEAL) {
                    mealInvoices.push({
                        documentRef: this.props.allowance.invoiceData.invoiceDocuments[i].documentRef,
                        fileContent: null,
                        filename: this.props.allowance.invoiceData.invoiceDocuments[i].filename,
                    });
                }
            }
        }

        this.setState({
            carKms: (this.props.allowance.invoiceData !== null && this.props.allowance.invoiceData.kms !== null) ? this.props.allowance.invoiceData.kms : this.props.allowance.allowanceTravelMealHotel.carKms,
            carTotal: (this.props.allowance.invoiceData !== null && this.props.allowance.invoiceData.kmsValue !== null) ? this.props.allowance.invoiceData.kmsValue : (this.props.allowance.allowanceTravelMealHotel.carKms * UNIT_KM_VALUE).toFixed(2),
            mealNumber: (this.props.allowance.invoiceData !== null && this.props.allowance.invoiceData.mealNumber !== null) ? this.props.allowance.invoiceData.mealNumber : this.props.allowance.allowanceTravelMealHotel.mealNumber,
            mealTotal: (this.props.allowance.invoiceData !== null && this.props.allowance.invoiceData.mealValue !== null) ? this.props.allowance.invoiceData.mealValue : null,
            busTotal: (this.props.allowance.invoiceData !== null && this.props.allowance.invoiceData.busValue !== null) ? this.props.allowance.invoiceData.busValue : (Number(this.props.allowance.allowanceTravelMealHotel.busPrice) + Number(this.props.allowance.allowanceTravelMealHotel.busReturnPrice)),
            trainTotal: (this.props.allowance.invoiceData !== null && this.props.allowance.invoiceData.trainValue !== null) ? this.props.allowance.invoiceData.trainValue : (Number(this.props.allowance.allowanceTravelMealHotel.trainPrice) + Number(this.props.allowance.allowanceTravelMealHotel.trainReturnPrice)),
            planeTotal: (this.props.allowance.invoiceData !== null && this.props.allowance.invoiceData.planeValue !== null) ? this.props.allowance.invoiceData.planeValue : (Number(this.props.allowance.allowanceTravelMealHotel.planePrice) + Number(this.props.allowance.allowanceTravelMealHotel.planeReturnPrice)),
            taxiTotal: (this.props.allowance.invoiceData !== null && this.props.allowance.invoiceData.taxiValue !== null) ? this.props.allowance.invoiceData.taxiValue : (Number(this.props.allowance.allowanceTravelMealHotel.taxiPrice) + Number(this.props.allowance.allowanceTravelMealHotel.taxiReturnPrice)),
            hotelNumNights: (this.props.allowance.invoiceData !== null && this.props.allowance.invoiceData.hotelNumberNights !== null) ? this.props.allowance.invoiceData.hotelNumberNights : null,
            hotelTotal: (this.props.allowance.invoiceData !== null && this.props.allowance.invoiceData.hotelValue !== null) ? this.props.allowance.invoiceData.hotelValue : null,
            busInvoices: busInvoices,
            trainInvoices: trainInvoices,
            planeInvoices: planeInvoices,
            taxiInvoices: taxiInvoices,
            hotelInvoices: hotelInvoices,
            mealInvoices: mealInvoices,
            hasBusExpenses: this.props.allowance.allowanceTravelMealHotel.bus && this.props.allowance.allowanceTravelMealHotel.busExpenseDecision === ASSOCIATE_SUBMISSION,
            hasTrainExpenses: this.props.allowance.allowanceTravelMealHotel.train && this.props.allowance.allowanceTravelMealHotel.trainExpenseDecision === ASSOCIATE_SUBMISSION,
            hasTaxiExpenses: this.props.allowance.allowanceTravelMealHotel.taxi && this.props.allowance.allowanceTravelMealHotel.taxiExpenseDecision === ASSOCIATE_SUBMISSION,
            hasCarExpenses: this.props.allowance.allowanceTravelMealHotel.car && this.props.allowance.allowanceTravelMealHotel.carExpenseDecision === ASSOCIATE_SUBMISSION,
            hasPlaneExpenses: this.props.allowance.allowanceTravelMealHotel.plane && this.props.allowance.allowanceTravelMealHotel.planeExpenseDecision === ASSOCIATE_SUBMISSION,
            hasMealExpenses: this.props.allowance.allowanceTravelMealHotel.meal && this.props.allowance.allowanceTravelMealHotel.mealExpenseDecision === ASSOCIATE_SUBMISSION,
            hasHotelExpenses: this.props.allowance.allowanceTravelMealHotel.hotel && this.props.allowance.allowanceTravelMealHotel.hotelExpenseDecision === ASSOCIATE_SUBMISSION,
        });

        if(this.props.allowance.dailyData !== null) {
            this.setState({
                dailyEntries: [
                    { allowanceDayType: ALLOWANCE_DAILY_TYPE_25, description: this.props.t("allowances.dialog.daily.25-days-description"), numDays: this.props.allowance.dailyData.num25Days, total: this.props.allowance.dailyData.total25Days, unitPrice: this.props.allowance.dailyData.unitPrice25Days },
                    { allowanceDayType: ALLOWANCE_DAILY_TYPE_50, description: this.props.t("allowances.dialog.daily.50-days-description"), numDays: this.props.allowance.dailyData.num50Days, total: this.props.allowance.dailyData.total50Days, unitPrice: this.props.allowance.dailyData.unitPrice50Days },
                    { allowanceDayType: ALLOWANCE_DAILY_TYPE_75, description: this.props.t("allowances.dialog.daily.75-days-description"), numDays: this.props.allowance.dailyData.num75Days, total: this.props.allowance.dailyData.total75Days, unitPrice: this.props.allowance.dailyData.unitPrice75Days },
                    { allowanceDayType: ALLOWANCE_DAILY_TYPE_100, description: this.props.t("allowances.dialog.daily.complete-days-description"), numDays: this.props.allowance.dailyData.numCompleteDays, total: this.props.allowance.dailyData.totalCompleteDays, unitPrice: this.props.allowance.dailyData.unitPriceCompleteDays }
                ]
            });

            setTimeout(() => {
                if(this.props.allowance.allowanceTravelMealHotel.payment) {
                    this.calculateDailyExpenses();
                }
            }, 1000);
        }
        else {
            if(this.props.allowance.allowanceTravelMealHotel.payment) {
                this.calculateDailyExpenses();
            }
        }   
    }

    invoiceLinkTemplate(document) {
        return <a className='c-pointer' onClick={() => this.downloadDocument(document.fileContent, document.filename, document.documentRef)}>{document.filename}</a>;
    }

    actionsBodyTemplate(rowData, collection) {
           return <div className='t-align-center'>
                <Button icon="pi pi-times-circle" size='small' severity="danger" tooltip={this.props.t("allowances.dialog.expenses.remove-invoice")} iconPos="center" onClick={() => this.removeInvoice(rowData.filename, collection)} />
            </div>;
     }

     amountBodyTemplate(rowData) {

        if(rowData.price.toString().includes(".")) {
            let amountParts = rowData.price.toString().split(".");

            if(amountParts[1].length === 1) {
                return rowData.price + "0 €";
            }
            else {
                return rowData.price + " €";
            }     
        }
        else {
            return rowData.price + ".00 €";
        }
        
        return "";
    }

     removeInvoice(filename, collection) {
        let invoices = [];
        let invoicesToRemove = this.state.invoicesToRemove;

        for (let i = 0; i < this.state[collection].length; i++) {
            if(filename !== this.state[collection][i].filename) {
                invoices.push(this.state[collection][i]);
            }
            else {
                if(this.state[collection][i].documentRef !== null) {
                    invoicesToRemove.push(this.state[collection][i].documentRef); 
                }
            }
        }

        this.setState({
            [collection]: invoices,
            invoicesToRemove: invoicesToRemove
        })
     }

    getAllowanceStateControl(allowance) {
        if(allowance.allowanceStateId === ORGANIC_UNIT_APPROVAL) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("allowances.form.in-approval")}</span>;
        }
        else if(allowance.allowanceStateId === FINANCE_APPROVAL) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("allowances.form.in-approval")}</span>;
        }
        else if(allowance.allowanceStateId === DIRECTION_APPROVAL) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("allowances.form.in-approval")}</span>;
        }
        else if(allowance.allowanceStateId === DECISION_WAIT_PAYMENT) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("allowances.form.wait-payment")}</span>;
        }
        else if(allowance.allowanceStateId === DECISION_WAIT_EXPENSE_SUBMISSION) {
            return <span className={'state-badge'} style={{background: '#feffb3', color: '#000000'}}>{this.props.t("allowances.form.wait-expense-submission")}</span>;
        }
        else if(allowance.allowanceStateId === ALLOWANCE_APPROVED){
            return <span className={'state-badge'} style={{background: '#C8E6C9', color: '#256029'}}>{this.props.t("allowances.form.approved")}</span>;
         }
        else {
          return <span className={'state-badge'} style={{background: '#b80406', color: '#FFFFFF'}}>{this.props.t("allowances.form.not-approved")}</span>;
       }
    }

    updateFormComponent(column, value) {
        this.setState({
            [column]: value
        });
    }

    uploadDocumentHandler(document, dataCollection, uploadFileRef) {
        let self = this;
        var reader = new FileReader();
        reader.readAsBinaryString(document[0]);

        reader.onload = function() {

            let collection = self.state[dataCollection];
            collection.push({
                documentRef: null,
                fileContent: btoa(reader.result),
                filename: document[0].name
            })

            self.setState({
                [dataCollection]: collection,
                validUploadFile: true
            });

            uploadFileRef.current.clear();
        };
    }

    downloadDocument(fileContent, filename, documentRef) { 
        if(documentRef === null) {
            var blob = new Blob([convertBase64ToArrayBuffer(fileContent)], { type: "application/pdf" });
            downloadFile(URL.createObjectURL(blob), filename);
        }
        else {
            AllowanceService.downloadAllowanceInvoice({ allowanceRef: this.props.allowance.allowanceRef, documentRef: documentRef })
            .then((response) => {
                  var blob = new Blob([convertBase64ToArrayBuffer(response.fileContent)], { type: response.contentType });
                  downloadFile(URL.createObjectURL(blob), response.filename);
            })
            .catch(error => {
                this._toast.current.show({ severity: 'error', detail: this.props.t("profile.messages.error"), life: 3000 });
            });
        }
    }

    updateTotalKm(kms) {
        this.setState({
            carKms: kms,
            carTotal: kms !== "" ? (kms * UNIT_KM_VALUE).toFixed(2) : null
        });
    }

    submitExpenses() {
        if(this.validateForm()) {
            AllowanceService.submitAllowanceInvoices({
                allowanceRef: this.props.allowance.allowanceRef,
                observations: "",
                hotelNumberNights: this.state.hotelNumNights ? Number(this.state.hotelNumNights) : null,
                hotelValue: this.state.hasHotelExpenses && this.state.hotelTotal ? Number(this.state.hotelTotal) : null,
                mealNumber: this.state.hasMealExpenses && this.state.mealNumber ? Number(this.state.mealNumber) : null,
                mealValue: this.state.hasMealExpenses && this.state.mealTotal ? Number(this.state.mealTotal) : null,
                busValue: this.state.hasBusExpenses && this.state.busTotal ? Number(this.state.busTotal) : null,
                trainValue: this.state.hasTrainExpenses && this.state.trainTotal ? Number(this.state.trainTotal) : null,
                taxiValue: this.state.hasTaxiExpenses && this.state.taxiTotal ? Number(this.state.taxiTotal) : null,
                planeValue: this.state.hasPlaneExpenses && this.state.planeTotal ? Number(this.state.planeTotal) : null,
                kms: this.state.hasCarExpenses && this.state.carKms ? Number(this.state.carKms) : null,
                kmsValue: this.state.hasCarExpenses && this.state.carTotal ? Number(this.state.carTotal) : null
            }).then((response) => { 
                // Remove invoices marked for deletion
                for (let i = 0; i < this.state.invoicesToRemove.length; i++) {
                    AllowanceService.removeAllowanceInvoice({ allowanceRef: this.props.allowance.allowanceRef, documentRef: this.state.invoicesToRemove[i] })
                    .then((response) => { })
                    .catch(error => {
                        this._toast.current.show({ severity: 'error', detail: this.props.t("profile.messages.error"), life: 3000 });
                    });
                }

                this.uploadExpenseInvoices();
                
                if(!this.props.allowance.allowanceTravelMealHotel.payment) {
                    this.props.onClose();
                }
            })
            .catch(error => {
                console.error(error);
            });

            if(this.props.allowance.allowanceTravelMealHotel.payment) {
                AllowanceService.submitAllowanceDailies({
                    allowanceRef: this.props.allowance.allowanceRef,
                    numCompleteDays: this.state.dailyTotalData.numCompleteDays,
                    totalCompleteDays: this.state.dailyTotalData.totalCompleteDays,
                    num75Days: this.state.dailyTotalData.num75Days,
                    total75Days: this.state.dailyTotalData.total75Days,
                    num50Days: this.state.dailyTotalData.num50Days,
                    total50Days: this.state.dailyTotalData.total50Days,
                    num25Days: this.state.dailyTotalData.num25Days,
                    total25Days: this.state.dailyTotalData.total25Days,
                    numMealDays: this.state.dailyTotalData.numMealDays,
                    totalMealDays: this.state.dailyTotalData.totalMealDays,
                    total: this.state.dailyTotalData.total
                }).then((response) => { 
                    this.props.onClose();
                })
                .catch(error => {
                    console.error(error);
                });
            }
        }
    }

    calculateDailyExpenses() {
        AllowanceService.calculateAllowanceDailyTotal({
            allowanceRef: this.props.allowance.allowanceRef
        }).then((response) => { 
            this.setState({
                dailyTotalData: response.allowanceDaily
            });

            this.setState({
                dailyEntries: [
                    { allowanceDayType: ALLOWANCE_DAILY_TYPE_25, description: this.props.t("allowances.dialog.daily.25-days-description"), numDays: response.allowanceDaily.num25Days, total: response.allowanceDaily.total25Days, unitPrice: response.allowanceDaily.unitPrice25Days },
                    { allowanceDayType: ALLOWANCE_DAILY_TYPE_50, description: this.props.t("allowances.dialog.daily.50-days-description"), numDays: response.allowanceDaily.num50Days, total: response.allowanceDaily.total50Days, unitPrice: response.allowanceDaily.unitPrice50Days },
                    { allowanceDayType: ALLOWANCE_DAILY_TYPE_75, description: this.props.t("allowances.dialog.daily.75-days-description"), numDays: response.allowanceDaily.num75Days, total: response.allowanceDaily.total75Days, unitPrice: response.allowanceDaily.unitPrice75Days },
                    { allowanceDayType: ALLOWANCE_DAILY_TYPE_100, description: this.props.t("allowances.dialog.daily.complete-days-description"), numDays: response.allowanceDaily.numCompleteDays, total: response.allowanceDaily.totalCompleteDays, unitPrice: response.allowanceDaily.unitPriceCompleteDays }
                ]
            });
        })
        .catch(error => {
            console.error(error);
        });
    }

    calculateAllowanceTotal() {
        let total = 0;

        if(this.state.dailyTotalData !== null) {
            total += Number(this.state.dailyTotalData.total);           
        }        

        if(this.state.carTotal !== null) {
            total += Number(this.state.carTotal);
        }

        if(this.state.busTotal !== null) {
            total += Number(this.state.busTotal);
        }

        if(this.state.trainTotal !== null) {
            total += Number(this.state.trainTotal);
        }

        if(this.state.planeTotal !== null) {
            total += Number(this.state.planeTotal);
        }

        if(this.state.taxiTotal !== null) {
            total += Number(this.state.taxiTotal);
        }

        if(this.state.mealTotal !== null) {
            total += Number(this.state.mealTotal);
        }

        if(this.state.hotelTotal !== null) {
            total += Number(this.state.hotelTotal);
        }

        return this.amountBodyTemplate({ price: total.toFixed(2) });
    }

    uploadExpenseInvoices() {
        if(this.props.allowance.allowanceTravelMealHotel.bus) {
            for (let i = 0; i < this.state.busInvoices.length; i++) {
                if(this.state.busInvoices[i].documentRef === null) {
                    AllowanceService.uploadAllowanceInvoice({
                        allowanceRef: this.props.allowance.allowanceRef,
                        expenseType: ALLOWANCE_EXPENSE_TYPE_BUS,
                        filename: this.state.busInvoices[i].filename,
                        fileContent: this.state.busInvoices[i].fileContent
                    }).then((response) => {})
                    .catch(error => { console.error(error); });
                }
            }
        }

        if(this.props.allowance.allowanceTravelMealHotel.train) {
            for (let i = 0; i < this.state.trainInvoices.length; i++) {
                if(this.state.trainInvoices[i].documentRef === null) {
                    AllowanceService.uploadAllowanceInvoice({
                        allowanceRef: this.props.allowance.allowanceRef,
                        expenseType: ALLOWANCE_EXPENSE_TYPE_TRAIN,
                        filename: this.state.trainInvoices[i].filename,
                        fileContent: this.state.trainInvoices[i].fileContent
                    }).then((response) => {})
                    .catch(error => { console.error(error); });
                }
            }
        }

        if(this.props.allowance.allowanceTravelMealHotel.taxi) {
            for (let i = 0; i < this.state.taxiInvoices.length; i++) {
                if(this.state.taxiInvoices[i].documentRef === null) {
                    AllowanceService.uploadAllowanceInvoice({
                        allowanceRef: this.props.allowance.allowanceRef,
                        expenseType: ALLOWANCE_EXPENSE_TYPE_TAXI,
                        filename: this.state.taxiInvoices[i].filename,
                        fileContent: this.state.taxiInvoices[i].fileContent
                    }).then((response) => {})
                    .catch(error => { console.error(error); });
                }
            }
        }

        if(this.props.allowance.allowanceTravelMealHotel.plane) {
            for (let i = 0; i < this.state.planeInvoices.length; i++) {
                if(this.state.planeInvoices[i].documentRef === null) {
                    AllowanceService.uploadAllowanceInvoice({
                        allowanceRef: this.props.allowance.allowanceRef,
                        expenseType: ALLOWANCE_EXPENSE_TYPE_PLANE,
                        filename: this.state.planeInvoices[i].filename,
                        fileContent: this.state.planeInvoices[i].fileContent
                    }).then((response) => {})
                    .catch(error => { console.error(error); });
                }
            }
        }

        if(this.props.allowance.allowanceTravelMealHotel.hotel) {
            for (let i = 0; i < this.state.hotelInvoices.length; i++) {
                if(this.state.hotelInvoices[i].documentRef === null) {
                    AllowanceService.uploadAllowanceInvoice({
                        allowanceRef: this.props.allowance.allowanceRef,
                        expenseType: ALLOWANCE_EXPENSE_TYPE_HOTEL,
                        filename: this.state.hotelInvoices[i].filename,
                        fileContent: this.state.hotelInvoices[i].fileContent
                    }).then((response) => {})
                    .catch(error => { console.error(error); });
                }
            }
        }

        if(this.props.allowance.allowanceTravelMealHotel.meal) {
            for (let i = 0; i < this.state.mealInvoices.length; i++) {
                if(this.state.mealInvoices[i].documentRef === null) {
                    AllowanceService.uploadAllowanceInvoice({
                        allowanceRef: this.props.allowance.allowanceRef,
                        expenseType: ALLOWANCE_EXPENSE_TYPE_MEAL,
                        filename: this.state.mealInvoices[i].filename,
                        fileContent: this.state.mealInvoices[i].fileContent
                    }).then((response) => {})
                    .catch(error => { console.error(error); });
                }
            }
        }
    }

    validateForm() {

        this.setState({
            hasCarKms: (!this.props.allowance.allowanceTravelMealHotel.car || this.props.allowance.allowanceTravelMealHotel.carExpenseDecision !== ASSOCIATE_SUBMISSION || (this.state.carKms !== null && this.state.carKms !== "")),
            hasBusInvoices: (!this.props.allowance.allowanceTravelMealHotel.bus || this.props.allowance.allowanceTravelMealHotel.busExpenseDecision !== ASSOCIATE_SUBMISSION || this.state.busInvoices.length > 0),
            hasBusTotal: (!this.props.allowance.allowanceTravelMealHotel.bus || this.props.allowance.allowanceTravelMealHotel.busExpenseDecision !== ASSOCIATE_SUBMISSION || (this.state.busTotal !== null && this.state.busTotal !== "")),
            hasTrainInvoices: (!this.props.allowance.allowanceTravelMealHotel.train || this.props.allowance.allowanceTravelMealHotel.trainExpenseDecision !== ASSOCIATE_SUBMISSION || this.state.trainInvoices.length > 0),
            hasTrainTotal: (!this.props.allowance.allowanceTravelMealHotel.train || this.props.allowance.allowanceTravelMealHotel.trainExpenseDecision !== ASSOCIATE_SUBMISSION || (this.state.trainTotal !== null && this.state.trainTotal !== "")),
            hasTaxiInvoices: (!this.props.allowance.allowanceTravelMealHotel.taxi || this.props.allowance.allowanceTravelMealHotel.taxiExpenseDecision !== ASSOCIATE_SUBMISSION || this.state.taxiInvoices.length > 0),
            hasTaxiTotal: (!this.props.allowance.allowanceTravelMealHotel.taxi || this.props.allowance.allowanceTravelMealHotel.taxiExpenseDecision !== ASSOCIATE_SUBMISSION || (this.state.taxiTotal !== null && this.state.taxiTotal !== "")),
            hasPlaneInvoices: (!this.props.allowance.allowanceTravelMealHotel.plane || this.props.allowance.allowanceTravelMealHotel.planeExpenseDecision !== ASSOCIATE_SUBMISSION || this.state.planeInvoices.length > 0),
            hasPlaneTotal: (!this.props.allowance.allowanceTravelMealHotel.plane || this.props.allowance.allowanceTravelMealHotel.planeExpenseDecision !== ASSOCIATE_SUBMISSION || (this.state.planeTotal !== null && this.state.planeTotal !== "")),
            hasHotelInvoices: (!this.props.allowance.allowanceTravelMealHotel.hotel || this.props.allowance.allowanceTravelMealHotel.hotelExpenseDecision !== ASSOCIATE_SUBMISSION || this.state.hotelInvoices.length > 0),
            hasHotelTotal: (!this.props.allowance.allowanceTravelMealHotel.hotel || this.props.allowance.allowanceTravelMealHotel.hotelExpenseDecision !== ASSOCIATE_SUBMISSION || (this.state.hotelTotal !== null && this.state.hotelTotal !== "")),
            hasHotelNumNights: (!this.props.allowance.allowanceTravelMealHotel.hotel || this.props.allowance.allowanceTravelMealHotel.hotelExpenseDecision !== ASSOCIATE_SUBMISSION || (this.state.hotelNumNights !== null && this.state.hotelNumNights !== "")),
            hasMealInvoices: (!this.props.allowance.allowanceTravelMealHotel.meal || this.props.allowance.allowanceTravelMealHotel.mealExpenseDecision !== ASSOCIATE_SUBMISSION || this.state.mealInvoices.length > 0),
            hasMealTotal: (!this.props.allowance.allowanceTravelMealHotel.meal || this.props.allowance.allowanceTravelMealHotel.mealExpenseDecision !== ASSOCIATE_SUBMISSION || (this.state.mealTotal !== null && this.state.mealTotal !== "")),
            hasMealNumber: (!this.props.allowance.allowanceTravelMealHotel.meal || this.props.allowance.allowanceTravelMealHotel.mealExpenseDecision !== ASSOCIATE_SUBMISSION || (this.state.mealNumber !== null && this.state.mealNumber !== ""))
        });

        return (
            (!this.props.allowance.allowanceTravelMealHotel.car || this.props.allowance.allowanceTravelMealHotel.carExpenseDecision !== ASSOCIATE_SUBMISSION || (this.state.carKms !== null && this.state.carKms !== "")) &&
            (!this.props.allowance.allowanceTravelMealHotel.bus || this.props.allowance.allowanceTravelMealHotel.busExpenseDecision !== ASSOCIATE_SUBMISSION || this.state.busInvoices.length > 0) &&
            (!this.props.allowance.allowanceTravelMealHotel.bus || this.props.allowance.allowanceTravelMealHotel.busExpenseDecision !== ASSOCIATE_SUBMISSION || (this.state.busTotal !== null && this.state.busTotal !== "")) &&
            (!this.props.allowance.allowanceTravelMealHotel.train || this.props.allowance.allowanceTravelMealHotel.trainExpenseDecision !== ASSOCIATE_SUBMISSION || this.state.trainInvoices.length > 0) &&
            (!this.props.allowance.allowanceTravelMealHotel.train || this.props.allowance.allowanceTravelMealHotel.trainExpenseDecision !== ASSOCIATE_SUBMISSION || (this.state.trainTotal !== null && this.state.trainTotal !== "")) &&
            (!this.props.allowance.allowanceTravelMealHotel.taxi || this.props.allowance.allowanceTravelMealHotel.taxiExpenseDecision !== ASSOCIATE_SUBMISSION || this.state.taxiInvoices.length > 0) &&
            (!this.props.allowance.allowanceTravelMealHotel.taxi || this.props.allowance.allowanceTravelMealHotel.taxiExpenseDecision !== ASSOCIATE_SUBMISSION || (this.state.taxiTotal !== null && this.state.taxiTotal !== "")) &&
            (!this.props.allowance.allowanceTravelMealHotel.plane || this.props.allowance.allowanceTravelMealHotel.planeExpenseDecision !== ASSOCIATE_SUBMISSION || this.state.planeInvoices.length > 0) &&
            (!this.props.allowance.allowanceTravelMealHotel.plane || this.props.allowance.allowanceTravelMealHotel.planeExpenseDecision !== ASSOCIATE_SUBMISSION || (this.state.planeTotal !== null && this.state.planeTotal !== "")) &&
            (!this.props.allowance.allowanceTravelMealHotel.hotel || this.props.allowance.allowanceTravelMealHotel.hotelExpenseDecision !== ASSOCIATE_SUBMISSION || this.state.hotelInvoices.length > 0) &&
            (!this.props.allowance.allowanceTravelMealHotel.hotel || this.props.allowance.allowanceTravelMealHotel.hotelExpenseDecision !== ASSOCIATE_SUBMISSION || (this.state.hotelTotal !== null && this.state.hotelTotal !== "")) &&
            (!this.props.allowance.allowanceTravelMealHotel.hotel || this.props.allowance.allowanceTravelMealHotel.hotelExpenseDecision !== ASSOCIATE_SUBMISSION || (this.state.hotelNumNights !== null && this.state.hotelNumNights !== "")) &&
            (!this.props.allowance.allowanceTravelMealHotel.meal || this.props.allowance.allowanceTravelMealHotel.mealExpenseDecision !== ASSOCIATE_SUBMISSION || this.state.mealInvoices.length > 0) &&
            (!this.props.allowance.allowanceTravelMealHotel.meal || this.props.allowance.allowanceTravelMealHotel.mealExpenseDecision !== ASSOCIATE_SUBMISSION || (this.state.mealTotal !== null && this.state.mealTotal !== "")) &&
            (!this.props.allowance.allowanceTravelMealHotel.meal || this.props.allowance.allowanceTravelMealHotel.mealExpenseDecision !== ASSOCIATE_SUBMISSION || (this.state.mealNumber !== null && this.state.mealNumber !== ""))
        );
    }

    render() {

        return (
            this.props.allowance !== null ?
                <div className="grid mgt-10">
                    <div className="col-6 t-align-left">
                        <label style={{fontSize: "16px"}}><b>{this.props.t("allowances.dialog.common.form.allowance-ref")} {this.props.allowance.allowanceRef}</b></label>
                    </div>
                    <div className="col-6 t-align-right">
                        {this.getAllowanceStateControl(this.props.allowance)}
                    </div>
                    <div className="col-12 mgt-10">
                        <label><b>{this.props.t("allowances.dialog.expenses.travel-title")}</b></label>
                    </div>
                    <div className="col-12">
                        <Checkbox inputId="cb-car-travel" checked={this.state.hasCarExpenses} onChange={e => this.setState({ hasCarExpenses: e.checked })}></Checkbox>
                        <label htmlFor="cb-car-travel" className="mgt-5 ml-2">{this.props.t("allowances.dialog.expenses.car")}</label>
                    </div>
                    {
                        this.state.hasCarExpenses ?
                        <>
                            <div className="col-12 lg:col-3">
                                <div className="flex flex-column gap-2">
                                    <label className='mgr-10' htmlFor="car-kms">{this.props.t("allowances.dialog.expenses.car-km")}</label>
                                    <InputText maxLength={4} pattern="\d*" value={this.state.carKms} id="car-kms" type="text" onChange={(evt) => this.updateTotalKm(evt.target.value)} />
                                    { this.state.hasCarKms ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                </div>
                            </div>
                            <div className="col-12 lg:col-3">
                                <div className="flex flex-column gap-2">
                                    <label className='mgr-10' htmlFor="car-total">{this.props.t("allowances.dialog.expenses.car-total")}</label>
                                    <InputText disabled maxLength={6} pattern="\d*" value={this.state.carTotal} id="car-total" type="text" />
                                </div>
                            </div>
                        </>
                        : null
                    }
                    <div className="col-12">
                        <Checkbox inputId="cb-bus-travel" checked={this.state.hasBusExpenses} onChange={e => { 
                            if(this.state.busInvoices.length !== 0 && !e.checked) {
                                return;
                            }
                            else {
                                this.setState({ hasBusExpenses: e.checked });
                            }
                        }}></Checkbox>
                        <label htmlFor="cb-bus-travel" className="mgt-5 ml-2">{this.props.t("allowances.dialog.expenses.bus")}</label>
                    </div>
                    {
                        this.state.hasBusExpenses ?
                        <>
                            <div className="col-12">
                                <div className="col-12 lg:col-3">
                                    <div className="flex flex-column gap-2">
                                        <label className='mgr-10' htmlFor="bus-total">{this.props.t("allowances.dialog.expenses.bus-total")}</label>
                                        <InputText maxLength={6} pattern="\d*" value={this.state.busTotal} id="bus-total" type="text" onChange={(evt) => this.setState({busTotal: evt.target.value})} />
                                        { this.state.hasBusTotal ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                    </div>
                                </div>
                                <DataTable value={this.state.busInvoices} className="p-datatable-gridlines" showGridlines rows={12} dataKey="id" responsiveLayout="scroll" emptyMessage={this.props.t("allowances.messages.no-invoices")}>
                                    <Column field="filename" header={this.props.t("allowances.dialog.expenses.filename")} body={(data) => this.invoiceLinkTemplate(data)} />
                                    <Column field="documentRef" header={this.props.t("allowances.form.actions-header")} body={(data) => this.actionsBodyTemplate(data, 'busInvoices')} style={{ maxWidth: '50px' }} />
                                </DataTable>
                                <small><b>{this.props.t("allowances.dialog.expenses.footer-note")}</b></small>
                                { this.state.hasBusInvoices ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                            </div>
                            <div className="col-12 t-align-right">
                                <FileUpload multiple ref={this.busInvoiceUploadRef} 
                                            mode="basic" 
                                            accept="application/pdf"    
                                            chooseLabel={this.props.t("allowances.dialog.expenses.upload-invoice")}
                                            maxFileSize={1000000} 
                                            uploadHandler={(evt) => this.uploadDocumentHandler(evt.files, 'busInvoices', this.busInvoiceUploadRef)} customUpload={true} auto={true}
                                            onValidationFail={(evt) => this.setState({validUploadFile: false})} />
                            </div>
                        </>
                        : null
                    }
                    <div className="col-12">
                        <Checkbox inputId="cb-train-travel" checked={this.state.hasTrainExpenses} onChange={e => { 
                            if(this.state.trainInvoices.length !== 0 && !e.checked) {
                                return;
                            }
                            else {
                                this.setState({ hasTrainExpenses: e.checked });
                            }
                        }}></Checkbox>
                        <label htmlFor="cb-train-travel" className="mgt-5 ml-2">{this.props.t("allowances.dialog.expenses.train")}</label>
                    </div>
                    {
                        this.state.hasTrainExpenses ?
                        <>
                            <div className="col-12">
                                <div className="col-12 lg:col-3">
                                    <div className="flex flex-column gap-2">
                                        <label className='mgr-10' htmlFor="train-total">{this.props.t("allowances.dialog.expenses.train-total")}</label>
                                        <InputText maxLength={6} pattern="\d*" value={this.state.trainTotal} id="train-total" type="text" onChange={(evt) => this.setState({trainTotal: evt.target.value})} />
                                        { this.state.hasTrainTotal ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                    </div>
                                </div>
                                <DataTable value={this.state.trainInvoices} className="p-datatable-gridlines" showGridlines rows={12} dataKey="id" responsiveLayout="scroll" emptyMessage={this.props.t("allowances.messages.no-invoices")}>
                                    <Column field="filename" header={this.props.t("allowances.dialog.expenses.filename")} body={(data) => this.invoiceLinkTemplate(data)} />
                                    <Column field="documentRef" header={this.props.t("allowances.form.actions-header")} body={(data) => this.actionsBodyTemplate(data, 'trainInvoices')} style={{ maxWidth: '50px' }} />
                                </DataTable>
                                <small><b>{this.props.t("allowances.dialog.expenses.footer-note")}</b></small>
                                { this.state.hasTrainInvoices ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                            </div>
                            <div className="col-12 t-align-right">
                                <FileUpload multiple ref={this.trainInvoiceUploadRef} 
                                            mode="basic" 
                                            accept="application/pdf"    
                                            chooseLabel={this.props.t("allowances.dialog.expenses.upload-invoice")}
                                            maxFileSize={1000000} 
                                            uploadHandler={(evt) => this.uploadDocumentHandler(evt.files, 'trainInvoices', this.trainInvoiceUploadRef)} customUpload={true} auto={true}
                                            onValidationFail={(evt) => this.setState({validUploadFile: false})} />
                            </div>
                        </>
                        : null
                    }
                    <div className="col-12">
                        <Checkbox inputId="cb-taxi-travel" checked={this.state.hasTaxiExpenses} onChange={e => { 
                            if(this.state.taxiInvoices.length !== 0 && !e.checked) {
                                return;
                            }
                            else {
                                this.setState({ hasTaxiExpenses: e.checked });
                            }
                        }}></Checkbox>
                        <label htmlFor="cb-taxi-travel" className="mgt-5 ml-2">{this.props.t("allowances.dialog.expenses.taxi")}</label>
                    </div>
                    {
                        this.state.hasTaxiExpenses ?
                        <>
                            <div className="col-12">
                                <div className="col-12 lg:col-3">
                                    <div className="flex flex-column gap-2">
                                        <label className='mgr-10' htmlFor="taxi-total">{this.props.t("allowances.dialog.expenses.taxi-total")}</label>
                                        <InputText maxLength={6} pattern="\d*" value={this.state.taxiTotal} id="taxi-total" type="text" onChange={(evt) => this.setState({taxiTotal: evt.target.value})} />
                                        { this.state.hasTaxiTotal ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                    </div>
                                </div>
                                <DataTable value={this.state.taxiInvoices} className="p-datatable-gridlines" showGridlines rows={12} dataKey="id" responsiveLayout="scroll" emptyMessage={this.props.t("allowances.messages.no-invoices")}>
                                    <Column field="filename" header={this.props.t("allowances.dialog.expenses.filename")} body={(data) => this.invoiceLinkTemplate(data)} />
                                    <Column field="documentRef" header={this.props.t("allowances.form.actions-header")} body={(data) => this.actionsBodyTemplate(data, 'taxiInvoices')} style={{ maxWidth: '50px' }} />
                                </DataTable>
                                <small><b>{this.props.t("allowances.dialog.expenses.footer-note")}</b></small>
                                { this.state.hasTaxiInvoices ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                            </div>
                            <div className="col-12 t-align-right">
                                <FileUpload multiple ref={this.taxiInvoiceUploadRef} 
                                            mode="basic" 
                                            accept="application/pdf"    
                                            chooseLabel={this.props.t("allowances.dialog.expenses.upload-invoice")}
                                            maxFileSize={1000000} 
                                            uploadHandler={(evt) => this.uploadDocumentHandler(evt.files, 'taxiInvoices', this.taxiInvoiceUploadRef)} customUpload={true} auto={true}
                                            onValidationFail={(evt) => this.setState({validUploadFile: false})} />
                            </div>
                        </>
                        : null
                    }
                    <div className="col-12">
                        <Checkbox inputId="cb-plane-travel" checked={this.state.hasPlaneExpenses} onChange={e => { 
                            if(this.state.planeInvoices.length !== 0 && !e.checked) {
                                return;
                            }
                            else {
                                this.setState({ hasPlaneExpenses: e.checked });
                            }
                        }}></Checkbox>
                        <label htmlFor="cb-plane-travel" className="mgt-5 ml-2">{this.props.t("allowances.dialog.expenses.plane")}</label>
                    </div>
                    {
                        this.state.hasPlaneExpenses ?
                        <>
                            <div className="col-12">
                                <div className="col-12 lg:col-3">
                                    <div className="flex flex-column gap-2">
                                        <label className='mgr-10' htmlFor="plane-total">{this.props.t("allowances.dialog.expenses.plane-total")}</label>
                                        <InputText maxLength={6} pattern="\d*" value={this.state.planeTotal} id="plane-total" type="text" onChange={(evt) => this.setState({planeTotal: evt.target.value})} />
                                        { this.state.hasPlaneTotal ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                    </div>
                                </div>
                                <DataTable value={this.state.planeInvoices} className="p-datatable-gridlines" showGridlines rows={12} dataKey="id" responsiveLayout="scroll" emptyMessage={this.props.t("allowances.messages.no-invoices")}>
                                    <Column field="filename" header={this.props.t("allowances.dialog.expenses.filename")} body={(data) => this.invoiceLinkTemplate(data)} />
                                    <Column field="documentRef" header={this.props.t("allowances.form.actions-header")} body={(data) => this.actionsBodyTemplate(data, 'planeInvoices')} style={{ maxWidth: '50px' }} />
                                </DataTable>
                                <small><b>{this.props.t("allowances.dialog.expenses.footer-note")}</b></small>
                                { this.state.hasPlaneInvoices ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                            </div>
                            <div className="col-12 t-align-right">
                                <FileUpload multiple ref={this.planeInvoiceUploadRef} 
                                            mode="basic" 
                                            accept="application/pdf"    
                                            chooseLabel={this.props.t("allowances.dialog.expenses.upload-invoice")}
                                            maxFileSize={1000000} 
                                            uploadHandler={(evt) => this.uploadDocumentHandler(evt.files, 'planeInvoices', this.planeInvoiceUploadRef)} customUpload={true} auto={true}
                                            onValidationFail={(evt) => this.setState({validUploadFile: false})} />
                            </div>
                        </>
                        : null
                    }
                    {
                        this.props.allowance.allowanceTravelMealHotel.hotel || this.props.allowance.allowanceTravelMealHotel.meal ?
                            <>
                                <div className="col-12 mgt-10">
                                    <label><b>{this.props.t("allowances.dialog.expenses.hotel-meal-title")}</b></label>
                                </div>
                                <div className="col-12">
                                    <Checkbox inputId="cb-hotel-travel" checked={this.state.hasHotelExpenses} onChange={e => { 
                                        if(this.state.hotelInvoices.length !== 0 && !e.checked) {
                                            return;
                                        }
                                        else {
                                            this.setState({ hasHotelExpenses: e.checked });
                                        }
                                    }}></Checkbox>
                                    <label htmlFor="cb-hotel-travel" className="mgt-5 ml-2">{this.props.t("allowances.dialog.expenses.hotel")}</label>
                                </div>
                                {
                                    this.state.hasHotelExpenses ?
                                    <>
                                        <div className="col-12 lg:col-3">
                                            <div className="flex flex-column gap-2">
                                                <label className='mgr-10' htmlFor="hotel-num-nights">{this.props.t("allowances.dialog.expenses.hotel-num-nights")}</label>
                                                <InputText maxLength={2} pattern="\d*" value={this.state.hotelNumNights} id="hotel-num-nights" type="text" onChange={(evt) => this.setState({hotelNumNights: evt.target.value})} />
                                                { this.state.hasHotelNumNights ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                        </div>
                                        <div className="col-12 lg:col-3">
                                            <div className="flex flex-column gap-2">
                                                <label className='mgr-10' htmlFor="hotel-total">{this.props.t("allowances.dialog.expenses.hotel-total")}</label>
                                                <InputText maxLength={6} pattern="\d*" value={this.state.hotelTotal} id="hotel-total" type="text" onChange={(evt) => this.setState({hotelTotal: evt.target.value})} />
                                                { this.state.hasHotelTotal ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <DataTable value={this.state.hotelInvoices} className="p-datatable-gridlines" showGridlines rows={12} dataKey="id" responsiveLayout="scroll" emptyMessage={this.props.t("allowances.messages.no-invoices")}>
                                                <Column field="filename" header={this.props.t("allowances.dialog.expenses.filename")} body={(data) => this.invoiceLinkTemplate(data)} />
                                                <Column field="documentRef" header={this.props.t("allowances.form.actions-header")} body={(data) => this.actionsBodyTemplate(data, 'hotelInvoices')} style={{ maxWidth: '50px' }} />
                                            </DataTable>
                                            <small><b>{this.props.t("allowances.dialog.expenses.footer-note")}</b></small>
                                            { this.state.hasHotelInvoices ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                        </div>
                                        <div className="col-12 t-align-right">
                                            <FileUpload multiple ref={this.hotelInvoiceUploadRef} 
                                                        mode="basic" 
                                                        accept="application/pdf"    
                                                        chooseLabel={this.props.t("allowances.dialog.expenses.upload-invoice")}
                                                        maxFileSize={1000000} 
                                                        uploadHandler={(evt) => this.uploadDocumentHandler(evt.files, 'hotelInvoices', this.hotelInvoiceUploadRef)} customUpload={true} auto={true}
                                                        onValidationFail={(evt) => this.setState({validUploadFile: false})} />
                                        </div>
                                    </>
                                    : null
                                }
                                <div className="col-12">
                                    <Checkbox inputId="cb-meal-travel" checked={this.state.hasMealExpenses} onChange={e => { 
                                        if(this.state.mealInvoices.length !== 0 && !e.checked) {
                                            return;
                                        }
                                        else {
                                            this.setState({ hasMealExpenses: e.checked });
                                        }
                                    }}></Checkbox>
                                    <label htmlFor="cb-meal-travel" className="mgt-5 ml-2">{this.props.t("allowances.dialog.expenses.meal")}</label>
                                </div>
                                {
                                    this.state.hasMealExpenses ?
                                    <>
                                        <div className="col-12 lg:col-3">
                                            <div className="flex flex-column gap-2">
                                                <label className='mgr-10' htmlFor="meal-number">{this.props.t("allowances.dialog.expenses.meal-number")}</label>
                                                <InputText maxLength={2} pattern="\d*" value={this.state.mealNumber} id="meal-number" type="text" onChange={(evt) => this.setState({mealNumber: evt.target.value})} />
                                                { this.state.hasMealNumber ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                        </div>
                                        <div className="col-12 lg:col-3">
                                            <div className="flex flex-column gap-2">
                                                <label className='mgr-10' htmlFor="meal-total">{this.props.t("allowances.dialog.expenses.meal-total")}</label>
                                                <InputText maxLength={6} pattern="\d*" value={this.state.mealTotal} id="meal-total" type="text" onChange={(evt) => this.setState({mealTotal: evt.target.value})} />
                                                { this.state.hasMealTotal ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <DataTable value={this.state.mealInvoices} className="p-datatable-gridlines" showGridlines rows={12} dataKey="id" responsiveLayout="scroll" emptyMessage={this.props.t("allowances.messages.no-invoices")}>
                                                <Column field="filename" header={this.props.t("allowances.dialog.expenses.filename")} body={(data) => this.invoiceLinkTemplate(data)} />
                                                <Column field="documentRef" header={this.props.t("allowances.form.actions-header")} body={(data) => this.actionsBodyTemplate(data, 'mealInvoices')} style={{ maxWidth: '50px' }} />
                                            </DataTable>
                                            <small><b>{this.props.t("allowances.dialog.expenses.footer-note")}</b></small>
                                            { this.state.hasMealInvoices ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                                        </div>
                                        <div className="col-12 t-align-right">
                                            <FileUpload multiple ref={this.mealInvoiceUploadRef} 
                                                        mode="basic" 
                                                        accept="application/pdf"    
                                                        chooseLabel={this.props.t("allowances.dialog.expenses.upload-invoice")}
                                                        maxFileSize={1000000} 
                                                        uploadHandler={(evt) => this.uploadDocumentHandler(evt.files, 'mealInvoices', this.mealInvoiceUploadRef)} customUpload={true} auto={true}
                                                        onValidationFail={(evt) => this.setState({validUploadFile: false})} />
                                        </div>
                                    </>
                                    : null
                                }
                            </>
                            : 
                            null
                    }
                    {
                        this.props.allowance.allowanceTravelMealHotel.payment ?
                            <>
                                <div className="col-12 mgt-10">
                                    <label><b>{this.props.t("allowances.dialog.expenses.expenses-title")}</b></label>
                                </div>
                                <div className="col-12">
                                    <DataTable value={this.state.dailyEntries} className="p-datatable-gridlines" showGridlines rows={12} dataKey="id" responsiveLayout="scroll" emptyMessage={this.props.t("allowances.messages.no-dailies")}>
                                        <Column field="description" header={this.props.t("allowances.dialog.daily.description-header")} />
                                        <Column field="unitPrice" header={this.props.t("allowances.dialog.daily.unit-price-header")} body={(data) => this.amountBodyTemplate({ price: data.unitPrice })} style={{ maxWidth: '120px' }}  />
                                        <Column field="numDays" header={this.props.t("allowances.dialog.daily.num-days-header")} />
                                        <Column field="total" header={this.props.t("allowances.dialog.daily.total-header")} body={(data) => this.amountBodyTemplate({ price: data.total })} />
                                    </DataTable>
                                </div>
                            </>
                            : 
                            null
                    }
                    <div className='col-12 t-align-right'>
                        <b style={{fontSize: "14px"}}>{this.props.t("allowances.dialog.daily.total")} { this.calculateAllowanceTotal() }</b>
                    </div>
                    <div className='col-12 t-align-right'>
                        <Button className='p-button-success' label={this.props.t("allowances.dialog.expenses.submit")} onClick={() => this.submitExpenses()} />
                    </div>
                </div>
            : null  
        );
    }
}

export default withTranslation(AllowanceExpenseSubmissionComponent);